import { Component } from "@angular/core";
import './pva-chart-legend.component.scss';

@Component({
    selector: 'pva-chart-legend',
    template: require('./pva-chart-legend.component.html')
})
export class PvaChartLegend {

}
